
import { APP_VERSION } from "@/utils/versionChecker";

const isStaging = window.location.hostname.includes("staging");

export const VersionInfo = () => {
  return (
    <div className={`text-xs ${isStaging ? "text-orange-500" : "text-slate-500"}`}>
      {isStaging ? "🛠️ Staging" : "🚀 Production"} v{APP_VERSION}
    </div>
  );
};
